/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import { ResumeSectionType } from './resume-section-type.enum';
import { ResumeSubSection } from '../sub-section/sub-section.model';

/**
 * Angular ResumeSection model.
 *
 * Information for a section of a {@link Resume}. About me, experience, etc.
 *
 */
export class ResumeSection {
  /**
   * Unique identifier for the section.
   */
  id : string;

  /**
   * The type of the section.
   */
  type : ResumeSectionType;

  /**
   * Whether the user has provided content for the section.
   */
  empty : boolean;

  /**
   * Array of sub-section for this section.
   */
  subSections : Array<ResumeSubSection> = new Array<ResumeSubSection>();

  /**
   * Default constructor.
   *
   * @param init Optional partial object definition.
   */
  constructor(init?:Partial<ResumeSection>) {
    Object.assign(this, init);
  }
}
